<div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="start start" class="m-8">
    <ng-container *ngIf="!ngControl.disabled; else detailMode">
        <mat-label>{{label}}</mat-label>
        <mat-form-field fxFlex="100%" appearance="outline" class="grow">
            <textarea matInput rows="4"
                [placeholder]="placeholder"
                [formControl]="ngControl.control"
                [maxlength]="maxLength"            
                #textAreaInput>
            </textarea>      
            
            <mat-hint align="end" class="mr-12">{{textAreaInput.value.length}} / {{maxLength}}</mat-hint>

            <!-- errors -->
            <ng-container *ngIf="ngControl.control.touched">
                <mat-error *ngIf="ngControl.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
                <mat-error *ngIf="ngControl.control.hasError('email')">{{'INPUT.INVALID_EMAIL' | translate}}</mat-error>
                <mat-error *ngIf="ngControl.control.hasError('maxlength')">{{'INPUT.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-error>
                <mat-error *ngIf="ngControl.control.hasError('max')">{{'INPUT.MAX_VALUE' | translate }}</mat-error>
                <mat-error *ngIf="ngControl.control.hasError('min')">{{'INPUT.MIN_VALUE' | translate }}</mat-error>
                <mat-error *ngIf="ngControl.control.hasError('pattern')">{{'INPUT.BAD_FORMAT' | translate }}</mat-error>
            </ng-container>
        </mat-form-field> 
    </ng-container>

    <ng-template #detailMode>
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <p *ngIf="ngControl.control.value" style="font-weight: bold;" fxFlex="100%" class="grow">{{ngControl.control.value}}</p>
        <p *ngIf="!ngControl.control.value" style="font-weight: bold;" fxFlex="100%" class="grow">{{'-'}}</p>
    </ng-template>
</div>

